import React from 'react';
import ReactDOM from 'react-dom/client';
import TaskManager from './components/TaskManager/TaskManager';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <h1>Welcome to the Home Management System!</h1>
    <TaskManager />
  </React.StrictMode>
);
